module.exports = __webpack_public_path__ + "70542eacbf0f038cd46f9f69a64644a7.MP3";